<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Update Payment Method</h1>
        </template>
        
        <div v-if="loaded">
            <p>Your current payment method is: <strong>{{ card.brand }}-{{ card.last_4 }}</strong></p>
            
            <div class="my-4 w-full">
                <card-input :stripe-key="stripeKey" :client-secret="clientSecret" ref="card"></card-input>
            </div>
        </div>
        <div v-else>
            <loading />
        </div>

        <template v-slot:footer v-if="loaded">
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                :loading="loading"
                state="Updating..."
                @click.native="submit"
            >
                Update
            </progressable-button>
            <button class="ml-2 py-2 px-4 rounded-md bg-primary-lightest" @click="close">Cancel</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    props: {
        card: {
            type    : Object,
            required: true,
        },
        endpoint: {
            type    : String,
            required: true,
        },
    },
    data() {
        return {
            loaded      : false,
            stripeKey   : null,
            clientSecret: null,
            loading     : false,
        }
    },
    mounted() {
        axios.post(`${this.endpoint}/intents`)
        .then(response => {
            this.stripeKey = response.data.data.key;
            this.clientSecret = response.data.data.intent;
            this.loaded = true;
        })
        .catch(err => {
            console.error(err);
        });
    },
    methods: {
        async submit() {
            this.loading = true;
            const paymentMethod = await this.$refs.card.tokenize();
            // if any error tokenizing, we'll bail out
            if (!paymentMethod) {
                this.loading = false;
                return;
            }
            
            axios.put(`${this.endpoint}/card`, {
                payment_method: paymentMethod,
            })
            .then(response => {
                this.$emit('resolve', response.data.data.card);
            })
            .catch(err => {
                console.error(err);
            }).then(() => {
                this.loading = false;
            });
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>